import { render, staticRenderFns } from "./banSomePerson.vue?vue&type=template&id=d0473baa&"
import script from "./banSomePerson.vue?vue&type=script&lang=js&"
export * from "./banSomePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0473baa')) {
      api.createRecord('d0473baa', component.options)
    } else {
      api.reload('d0473baa', component.options)
    }
    module.hot.accept("./banSomePerson.vue?vue&type=template&id=d0473baa&", function () {
      api.rerender('d0473baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banSomePerson.vue"
export default component.exports